<template>
  <cx-showcase-section :name="name" :link="link" class="cx-combobox-showcase">
    <div class="cx-combobox-showcase__row">
      <cx-combobox
        :items="items"
        :value="selectedItems"
        :input="changeSelectedItems"
        :label="'items'"
        isChips
        isTextInput
        isDropdown/>
      <cx-combobox
        :items="items"
        :value="selectedItems2"
        :input="changeSelectedItems2"
        :label="'disabled combobox'"
        :disabled="true"
        isTextInput
        isChips
        isDropdown/>
      <cx-combobox
        :items="items"
        :value="selectedItems2"
        :input="changeSelectedItems2"
        :label="'loading combobox'"
        :loading="true"
        isTextInput
        isChips
        isDropdown/>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxCombobox from '@/components/cxCombobox/CxCombobox';

export default {
  name: 'CxToggleShowcase',
  components: {
    CxShowcaseSection,
    CxCombobox,
  },
  data() {
    return {
      name: 'CxCombobox',
      link: '',
      items: [
        {
          id: 1,
          name: 'Test item 1',
          subtitle: 'subtitle 1',
        },
        {
          id: 2,
          name: 'Test item 2',
          subtitle: 'subtitle 2',
        },
        {
          id: 3,
          name: 'Test item 3',
          subtitle: 'subtitle 1',
        },
      ],
      selectedItems: [],
      selectedItems2: []
    };
  },
  methods: {
    changeSelectedItems(items) {
      this.selectedItems = items;
    },
    changeSelectedItems2(items) {
      this.selectedItems2 = items;
    }
  },
};
</script>

<style lang="less">
@import "../../../common";

.cx-combobox-showcase {

  .cx-combobox-showcase__row {
    display: flex;
    width: 100%;
    gap: 10px;
    flex: 1 1;
  }
}
</style>